/* unplugin-vue-components disabled */import script from "./ClassroomTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ClassroomTemplate.vue?vue&type=style&index=0&id=8c2eb0c0&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈尔滨医科大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c2eb0c0"]])

export default __exports__